<template>
  <div class="w-full">
    <v-form
      name="text-form"
      ref="textForm"
      v-model="isFormValid"
    >
      <v-row
        v-for="field of fields"
        :key="field.name"
        class="ma-0 pa-0 mb-4"
      >
        <CheckTextField
          :model-value="fieldsData[field.name]"
          @update:model-value="handleUpdate(field.name, $event)"
          :placeholder="field.placeholder"
          :loading="isLoading"
          :disabled="disabled"
          :rules="field.isRequired ? [rules.required] : []"
          outlined
          hide-details
          validate-on-input
          @click="onClick(field.name, fieldsData[field.name])"
        />
      </v-row>
    </v-form>
  </div>
</template>

<script>
import CheckTextField from '@/components/forms/CheckTextField'
import { required } from '@/lib/validation'

export default {
  components: {
    CheckTextField,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    hasDebounceTimer: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const fieldFlags = this.initFieldFlags()
    const fieldValues = this.mapFieldValues()

    return {
      fieldsData: { ...fieldValues },
      debounceTimeout: null,
      spinnerTimeout: null,
      isLoading: false,
      isFormValid: false,
      isFieldValid: fieldFlags,
    }
  },

  watch: {
    fields() {
      const fieldValues = this.mapFieldValues()
      this.fieldsData = { ...fieldValues }
    },
  },
  created() {
    this.rules = { required }
  },

  unmounted() {
    clearTimeout(this.spinnerTimeout)
    clearTimeout(this.debounceTimeout)
  },

  methods: {
    onClick(label, value) {
      this.$tracking.event('Settings', 'Clicked', label, value)
    },
    handleUpdate(fieldName, value) {
      this.fieldsData[fieldName] = value
      return this.update(fieldName, value)
    },
    async update() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.isLoading = true
        this.spinnerTimeout = setTimeout(async () => {
          const { valid } = await this.$refs.textForm.validate()
          if (valid) {
            this.$emit('update', this.fieldsData)
          }
          this.isLoading = false
        }, 1000)
      }, 2000)
    },
    initFieldFlags() {
      return this.fields.reduce((acc, field) => {
        acc[field.name] = false
        return acc
      }, {})
    },
    mapFieldValues() {
      return this.fields.reduce((acc, field) => {
        acc[field.name] = field.value
        return acc
      }, {})
    },
  },
  emits: ['update'],
}
</script>
